export default __webpack_public_path__ + "static/media/banner.a2128b08.png";